/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_New_Round_BodyInputs */

const en_us2_clubs_new_round_body = /** @type {(inputs: Clubs_New_Round_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It starts today, with the same people. The current round ends yesterday.`)
};

const pt_br2_clubs_new_round_body = /** @type {(inputs: Clubs_New_Round_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Começa hoje, com as mesmas pessoas. A rodada atual termina ontem.`)
};

const es_419_clubs_new_round_body = /** @type {(inputs: Clubs_New_Round_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empieza hoy, con las mismas personas. La ronda actual termina ayer.`)
};

const pt_pt2_clubs_new_round_body = /** @type {(inputs: Clubs_New_Round_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Começa hoje, com as mesmas pessoas. A ronda atual termina ontem.`)
};

const fr_fr2_clubs_new_round_body = /** @type {(inputs: Clubs_New_Round_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elle commence aujourd'hui, avec les mêmes personnes. La manche en cours est close à la date d'hier.`)
};

const de_de2_clubs_new_round_body = /** @type {(inputs: Clubs_New_Round_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie beginnt heute, mit denselben Leuten. Die aktuelle Runde endet gestern.`)
};

const it_it2_clubs_new_round_body = /** @type {(inputs: Clubs_New_Round_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizia oggi, con le stesse persone. Il turno attuale si chiude ieri.`)
};

/**
* | output |
* | --- |
* | "It starts today, with the same people. The current round ends yesterday." |
*
* @param {Clubs_New_Round_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_new_round_body = /** @type {((inputs?: Clubs_New_Round_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_New_Round_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_new_round_body(inputs)
	if (locale === "es-419") return es_419_clubs_new_round_body(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_new_round_body(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_new_round_body(inputs)
	if (locale === "de-DE") return de_de2_clubs_new_round_body(inputs)
	if (locale === "it-IT") return it_it2_clubs_new_round_body(inputs)
	return en_us2_clubs_new_round_body(inputs)
});
export { clubs_new_round_body as "clubs.new_round_body" }